<template>
  <div class="grid w-full gap-2 sm:items-end" :class="{
    'md:grid-cols-[1fr_1fr_1fr_1fr] grid-cols-[1fr_1fr]': localHasNewCost,
    'grid-cols-1': !localHasNewCost
  }">
    <!-- Input cantidad + botón agregar + botón estado sedes -->
    <div class="grid grid-cols-[1fr_auto_auto] w-full sm:w-auto">
      <input :type="type" v-model="localValue" @input="onQtyInput" @keyup.enter="addToCartHandler"
        v-tooltip="tooltipCantidad" :class="inputClasses" />

      <button @click="addToCartHandler" :class="[
        'px-3', 'pt-1', 'pb-0', 'text-md', 'font-medium',
        'uppercase', 'text-white', iconColor
      ]" type="button">
        <i :class="icon" v-tooltip="{ content: text, triggers: ['hover'] }"></i>
      </button>

      <!-- NUEVO -->
      <button @click="emitSedesStatus"
        class="rounded-r px-3 pt-1 pb-0 text-md font-medium uppercase text-white bg-slate-600 hover:bg-slate-700"
        type="button">
        <i class="bx bx-store-alt" v-tooltip="{ content: 'Ver estado en sedes', triggers: ['hover'] }"></i>
      </button>
      
    </div>
    <!-- Input descuento + botón aplicar -->
    <div v-if="localhasDiscount" class="grid grid-cols-[1fr_auto] w-full sm:w-auto">
      <input :type="type" v-model="localValueDiscount" @input="onDiscountInput" @keyup.enter="applyDiscountHandler"
        :class="inputClasses" />
      <button @click="applyDiscountHandler" :class="[
        'rounded-r', 'px-3', 'pt-1', 'pb-0', 'text-md', 'font-medium',
        'uppercase', 'text-white', iconColor
      ]" type="button">
        <i class="bx bxs-discount" v-tooltip="{ content: 'Aplicar descuento al producto', triggers: ['hover'] }"></i>
      </button>
    </div>

    <!-- Input nuevo costo + botón actualizar -->
    <div v-if="localHasNewCost" class="grid grid-cols-[1fr_auto] w-full sm:w-auto">
      <input type="number" step="0.01" v-model="localNewCost" @input="onCostInput" placeholder="Nuevo costo"
        :class="inputClasses" />
      <button @click="updateCostHandler" :class="[
        'rounded-r', 'px-3', 'pt-1', 'pb-0', 'text-md', 'font-medium',
        'uppercase', 'text-white',
        'bg-color-barrasuperior', 'hover:bg-primary-700'
      ]" type="button">
        <i class="bx bx-refresh" v-tooltip="{ content: 'Actualizar costo del producto', triggers: ['hover'] }"></i>
      </button>
    </div>

    <!-- Botón modal descuentos indexados -->
    <div v-if="localhasInedexesDiscount" class="grid grid-cols-[1fr_auto] w-full sm:w-auto"
      style="height: -webkit-fill-available;">
      <button @click="openModal"
        class="px-2 text-white bg-color-barrasuperior rounded hover:bg-primary-700 flex items-center w-fit"
        v-tooltip="{ content: 'Agregar descuentos indexados', triggers: ['hover'] }">
        <i class="bx bx-layer-plus text-lg"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "CartInput",

  emits: [
    "pending-change",
    "quality",
    "add-to-cart",
    "discount",
    "open-modal",
    "cost-updated",
    "sedes-status"
  ],

  props: {
    type: { type: String, default: "number" },
    placeholder: String,
    label: String,
    inputClass: String,
    text: String,
    content: { type: Object, required: true },
    icon: String,
    animate: Boolean,
    value: [String, Number],
    value2: [String, Number],
    hasDiscount: Boolean,
    hasNewCost: Boolean,
    hasInedexesDiscount: Boolean,
    CampoVmdInv: String,
  },

  data() {
    let vmdField = "vmd_inventario";
    if (this.CampoVmdInv === "vmd_grp") vmdField = "vmd";
    if (this.CampoVmdInv === "vmd_sum") vmdField = "vmd_sum";

    return {
      localValue: this.value ?? this.content.quantity ?? "",
      localValueDiscount: this.value2 ? parseFloat(this.value2).toFixed(2) : null,
      localContent: { ...this.content },
      localVmd: this.content[vmdField] ?? 1,
      localhasDiscount: !!this.hasDiscount,
      localhasInedexesDiscount: !!this.hasInedexesDiscount,
      localHasNewCost: !!this.hasNewCost,
      localNewCost: null,
    };
  },

  computed: {
    tooltipCantidad() {
      const quantity = parseFloat(this.localContent.quantity) || 0;
      const vmd = parseFloat(this.localVmd) || 1;
      const dias = (quantity > 0 && vmd > 0) ? Math.ceil(quantity / vmd) : 0;

      return {
        content: `
          <div class='text-center'>
            <div>La cantidad a pedir alcanzará</div>
            <div>para aproximadamente:</div>
            <div class='font-bold text-blue-700 text-lg mt-1'>${dias} días</div>
          </div>
        `,
        html: true
      };
    },

    inputClasses() {
      return [
        "relative", "m-0", "rounded-l", "block", "w-auto", "min-w-0",
        "flex-auto", "border", "border-solid", "border-neutral-300",
        "bg-transparent", "bg-clip-padding", "px-3", "py-[0.25rem]",
        "text-base", "font-normal", "leading-[1.6]", "text-neutral-700",
        "outline-none", "transition", "duration-200", "ease-in-out",
        "focus:z-[3]", "focus:border-primary", "focus:text-neutral-700",
        "focus:shadow-[inset_0_0_0_1px_rgb(59,113,202)]", "focus:outline-none",
        "dark:border-neutral-600", "dark:text-neutral-200",
        "dark:placeholder:text-neutral-200", "dark:focus:border-primary"
      ].join(" ");
    },

    iconColor() {
      return this.localContent.inCart && this.icon !== "bx bx-edit-alt"
        ? "bg-green-500"
        : "bg-color-barrasuperior";
    }
  },

  watch: {
    value(newVal) {
      this.localValue = newVal ?? "";
    },
    value2(newVal) {
      this.localValueDiscount = newVal ? parseFloat(newVal).toFixed(2) : null;
    },
    content: {
      deep: true,
      handler(newVal) {
        this.localContent = { ...newVal };
      }
    }
  },

  methods: {
    ...mapMutations("orders", ["addToCart"]),

    getKey() {
      return this.localContent.barra;
    },

    onQtyInput() {
      this.$emit("pending-change", {
        key: this.getKey(),
        field: "quantity",
        value: this.localValue
      });
    },

    onDiscountInput() {
      this.$emit("pending-change", {
        key: this.getKey(),
        field: "discountItem",
        value: this.localValueDiscount
      });
    },

    onCostInput() {
      this.$emit("pending-change", {
        key: this.getKey(),
        field: "new_cost",
        value: this.localNewCost
      });
    },

    addToCartHandler() {
      this.localContent.inCart = true;
      this.$emit("quality", this.localValue);
      this.$emit("add-to-cart", this.localContent);
    },

    applyDiscountHandler() {
      this.$emit("discount", this.localValueDiscount);
    },

    openModal() {
      this.$emit("open-modal");
    },

    updateCostHandler() {
      if (!this.localNewCost || isNaN(this.localNewCost)) {
        alert("Ingresa un costo válido");
        return;
      }
      this.$emit("cost-updated", {
        item: this.localContent.item,
        new_cost: parseFloat(this.localNewCost)
      });
    },
    emitSedesStatus() {
      this.$emit("sedes-status", {
        item: this.localContent?.item,
        barra: this.localContent?.barra,
        content: this.localContent
      });
    }
  }
};
</script>
